var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysChangeRanks = function SvgSysChangeRanks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 12.5V4.71L8.851 6.856a.497.497 0 0 1-.35.147.49.49 0 0 1-.35-.147.5.5 0 0 1 0-.707l2.968-2.966A.497.497 0 0 1 11.504 3a.502.502 0 0 1 .386.182l2.965 2.964a.505.505 0 0 1 .041.743.498.498 0 0 1-.741-.035l-2.15-2.149v7.793a.498.498 0 0 1-.5.5.498.498 0 0 1-.5-.5L11 12.5Zm-6.5.5a.49.49 0 0 1-.339-.135l-.013-.01-3-3a.503.503 0 0 1 .358-.818.502.502 0 0 1 .342.111l2.15 2.153V3.5a.5.5 0 0 1 1 0v7.793l2.148-2.148a.499.499 0 0 1 .814.367.497.497 0 0 1-.114.34l-3 3a.5.5 0 0 1-.355.143L4.5 13Z"
  })));
};
export default SvgSysChangeRanks;